import Vue from 'vue'
import App from './App.vue'
import 'material-icons/iconfont/material-icons.css'
import '../themeConfig.js'
import './assets/scss/main.scss'
import '@/assets/css/main.css'
import router from './router/router'
import store from './store/store'
import './filters/filters'
// @ts-ignore
import { VueHammer } from 'vue2-hammer'
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'
import axios from 'axios'
import i18n from './i18n/i18n'

import { localize } from 'vee-validate'
// @ts-ignore
import en from 'vee-validate/dist/locale/en'
// @ts-ignore
import ru from 'vee-validate/dist/locale/ru'
import 'piramis-base-components/src/assets/scss/main.scss'

localize({
  ru,
  en,
});

localize(i18n.locale)


Vue.use(require('vue-scrollto'))
Vue.use(VueHammer)

Vue.prototype.$http = axios

require('./assets/css/iconfont.css')


Vue.config.productionTip = false

import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
import FeatherIcon from '@/components/FeatherIcon.vue'

Vue.component(FeatherIcon.name, FeatherIcon)
Vue.use(Antd)

new Vue({
  router,
  i18n,
  store,
  render: h => h(App),
}).$mount('#app')
